import { filterRoutesByPermissions } from './menuItemHasAccess';
import { getMenuRoutes } from './getMenuRoutes';

const TOP_LEVEL_MAX_ID = 6;

const isStaticPath = (path) => typeof path === 'string' && path.length > 0 && !path.includes(':');

const buildSubtitle = (sectionTitle) => (sectionTitle ? `Nav · ${sectionTitle}` : 'Nav');

export const flattenPages = ({
  isAuthenticated,
  userEmail,
  isOffline,
  dashboardInfoSections,
  isAzAccount,
  userRoleType,
  userPermissions,
  modularityPermissions,
}) => {
  if (!isAuthenticated) return [];

  const routes = getMenuRoutes(isAuthenticated, userEmail, isOffline, dashboardInfoSections, isAzAccount, userRoleType);

  const sections = filterRoutesByPermissions(routes, userPermissions, modularityPermissions).filter(
    (item) => typeof item.id === 'number' && item.id <= TOP_LEVEL_MAX_ID,
  );

  const pages = [];

  sections.forEach((section) => {
    if (isStaticPath(section.path) && !section.href) {
      pages.push({
        id: `section-${section.id}`,
        type: 'page',
        title: section.title,
        path: section.path,
        sectionTitle: section.title,
        subtitle: 'Section',
      });
    }
    if (Array.isArray(section.subRoutes)) {
      section.subRoutes.forEach((sub) => {
        if (!isStaticPath(sub.path) || sub.href) return;
        pages.push({
          id: `${section.id}-${sub.id ?? sub.path}`,
          type: 'page',
          title: sub.title,
          path: sub.path,
          sectionTitle: section.title,
          subtitle: buildSubtitle(section.title),
        });
      });
    }
  });

  return pages;
};

export const getTopLevelSections = ({
  isAuthenticated,
  userEmail,
  isOffline,
  dashboardInfoSections,
  isAzAccount,
  userRoleType,
  userPermissions,
  modularityPermissions,
}) => {
  if (!isAuthenticated) return [];
  const routes = getMenuRoutes(isAuthenticated, userEmail, isOffline, dashboardInfoSections, isAzAccount, userRoleType);
  return filterRoutesByPermissions(routes, userPermissions, modularityPermissions).filter(
    (item) => typeof item.id === 'number' && item.id <= TOP_LEVEL_MAX_ID,
  );
};
